"use client";

import { Activity, ArrowUpRight } from "lucide-react";

/**
 * Publiczny adres strony statusowej. Można nadpisać zmienną środowiskową
 * `NEXT_PUBLIC_STATUS_URL` (np. na środowisku testowym).
 */
export const STATUS_PAGE_URL =
  process.env.NEXT_PUBLIC_STATUS_URL || "https://status.nextschool.pl";

interface StatusServiceHintProps {
  /** Dodatkowe klasy pozycjonujące dla kontenera. */
  className?: string;
  /** Kompaktowa wersja (mniejszy padding, jeden wiersz tekstu). */
  compact?: boolean;
}

/**
 * Podpowiedź „sprawdź dostępność naszych usług" — kieruje użytkownika na
 * publiczną stronę statusową, aby mógł ustalić, czy błąd wynika z chwilowej
 * awarii po naszej stronie. Używana na stronach błędów (404 / error).
 */
export default function StatusServiceHint({
  className = "",
  compact = false,
}: StatusServiceHintProps) {
  return (
    <a
      href={STATUS_PAGE_URL}
      target="_blank"
      rel="noopener noreferrer"
      className={`group inline-flex items-center gap-3 rounded-2xl border border-slate-200/70 bg-white/70 backdrop-blur ${
        compact ? "px-3.5 py-2.5" : "px-4 py-3.5"
      } text-left shadow-sm transition-all hover:border-blue-200 hover:bg-white hover:shadow-md ${className}`}
    >
      <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-xl bg-emerald-500/10 text-emerald-600">
        <Activity size={18} />
      </span>
      <span className="min-w-0">
        <span className="block text-sm font-semibold text-slate-800">
          Sprawdź dostępność naszych usług
        </span>
        {!compact && (
          <span className="block text-xs text-slate-500">
            Coś nie działa? Zobacz, czy to chwilowa awaria po naszej stronie.
          </span>
        )}
      </span>
      <ArrowUpRight
        size={16}
        className="ml-1 shrink-0 text-slate-400 transition-transform group-hover:-translate-y-0.5 group-hover:translate-x-0.5 group-hover:text-blue-500"
      />
    </a>
  );
}
